{
  "labelsPodatki": {
    "email": "Indirizzo email",
    "naslov": "Indirizzo",
    "posta": "CAP",
    "kraj": "Città",
    "telefon": "Telefono",
    "licenca": "Licenza",
    "buttons": {
      "odpri": "Modifica profilo pilota",
      "posodobi": "aggiorna"
    }
  },
  "obvestila": {
    "napakaBranja": "Errore durante la lettura dei dati.",
    "napakaInputa": "Il campo del codice non può essere vuoto!",
    "vprasanjeIzklopa": "Sei sicuro di voler disattivare il 2FA?",
    "izklopUspesen": "2FA disattivato con successo.",
    "vklopUspesen": "2FA attivato con successo.",
    "niUjemanja": "Il codice inserito non corrisponde. Controlla il codice e riprova!"
  }
}